export default __webpack_public_path__ + "static/media/Cross-icon.8534fbf3.svg";